import { Group, Stack, useMantineTheme } from '@mantine/core';

import type { AeropayBankName } from '~/common/enums/payments.enum';
import { Text } from '~/domains/design-system/Text';
import { BankIcon } from '~/domains/payments/icons/BankIcon';

interface BankAccountProps {
  bankAccount: {
    name: string;
    bankName: AeropayBankName;
  };
}
export function BankAccount({ bankAccount }: BankAccountProps) {
  const theme = useMantineTheme();
  return (
    <Stack
      sx={{
        borderRadius: theme.radius.md,
        border: `1px solid #D1D1D1`,
      }}
    >
      <Group
        w="100%"
        py={theme.other.spacing._12}
        px={theme.other.spacing._16}
        sx={{
          img: {
            width: 32,
            height: 32,
            borderRadius: theme.radius.sm,
          },
        }}
      >
        <BankIcon bankName={bankAccount.bankName} />
        <Stack align="flex-start" spacing={0} sx={{ flex: 1 }}>
          <Text variant="subhead-small" color="gray.9">
            {bankAccount.name}
          </Text>
          <Text variant="body-small" color="gray.6">
            {bankAccount.bankName}
          </Text>
        </Stack>
      </Group>
    </Stack>
  );
}
